export var componentsLocales = {
  loading: 'Loading'
};